/* eslint-disable no-nested-ternary */
import { PrimaryStatus, statusTranslation, ChartMetricField, ChartMetricList } from './../../../../const/dashboard';
import { IValidate } from './../../../../utils/validationUtil';
import { CampaignObjectiveValue } from './../../../../const/state/campaign';
import { TTCallToAction } from './../../../../const/creative';
import { formatNumberByLangCode, formatNumberWithUnit } from '@tt4b/infra-utils';
import { DEFAULT_LANG } from './../../../../i18n';
import { getCurrencyOffset } from './../../../../mixins/currencyMixin';

export function dynamicStyle(status): string {
  const ACTIVE = 'status-active';
  const INACTIVE = 'status-inactive';
  const NOT_DELIVERING = 'status-not-delivering';
  switch (status) {
    case PrimaryStatus.delivery_ok:
      return ACTIVE;
    case PrimaryStatus.closed:
    case PrimaryStatus.time_done:
    case PrimaryStatus.disable:
    case PrimaryStatus.frozen:
      return INACTIVE;
    default:
      return NOT_DELIVERING;
  }
}

export function dynamicPillLabel(status): string {
  const ACTIVE = statusTranslation[PrimaryStatus.delivery_ok] as string;
  const INACTIVE = statusTranslation[PrimaryStatus.disable] as string;
  const NOT_DELIVERING = statusTranslation[PrimaryStatus.not_delivery] as string;
  const CLOSED = statusTranslation[PrimaryStatus.closed] as string;
  const COMPLETED = statusTranslation[PrimaryStatus.time_done] as string;
  const TERMINATED = statusTranslation[PrimaryStatus.frozen] as string;
  switch (status) {
    case PrimaryStatus.delivery_ok:
      return ACTIVE;
    case PrimaryStatus.closed:
      return CLOSED;
    case PrimaryStatus.time_done:
      return COMPLETED;
    case PrimaryStatus.disable:
      return INACTIVE;
    case PrimaryStatus.not_delivery:
      return NOT_DELIVERING;
    case PrimaryStatus.frozen:
      return TERMINATED;
    default:
      return '';
  }
}

type Validator = (param: any) => any;

export async function changeNameValidation(
  validators: Validator[],
  newName: string,
): Promise<{ message: string; validate: boolean }> {
  for (let i = 0; i < validators.length; i++) {
    const validator: Validator = validators[i];
    const validatorRes: IValidate = await validator(newName);
    const { validate, message } = validatorRes;
    if (!validate) {
      return {
        validate,
        message: message as string,
      };
    }
  }
  return Promise.resolve({
    validate: true,
    message: '',
  });
}

export const OBJECTIVES_WITHOUT_EXTERNAL_URL = [
  CampaignObjectiveValue.AppInstall,
  CampaignObjectiveValue.AppPromotion,
  CampaignObjectiveValue.CommunityInteraction,
  CampaignObjectiveValue.LeadAds,
  CampaignObjectiveValue.VideoView,
  CampaignObjectiveValue.Reach,
];

export function getCallToActioni18nKey(call_to_action) {
  return TTCallToAction.find(cta => cta.id === call_to_action)?.key;
}

export const formatNumberByLangCodeUtil = (
  metric: number | string,
  explicitPrecision?: number,
  metricField?: string,
): string => {
  const removePercentageSignFromMetric = (param: string | number): string => param.toString()?.replaceAll('%', '');
  const newMetric: string = removePercentageSignFromMetric(metric);
  let denyPrecision = false;
  let percentageStr = '';
  if (metricField) {
    const [chartMetric] = ChartMetricList.filter(cm => metricField === cm.label);
    denyPrecision = !chartMetric.showDecimal;
    percentageStr = chartMetric.showPercentage ? '%' : '';
  }

  return `${formatNumberByLangCode({
    value: newMetric,
    platformLangCode: DEFAULT_LANG,
    precision: explicitPrecision !== undefined ? explicitPrecision : denyPrecision ? 0 : getCurrencyOffset(),
  })}${percentageStr}`;
};
